import * as momentLib from 'moment';
import { extendMoment } from 'moment-range';
import 'moment/locale/nl';
momentLib.locale('nl');
export { Moment } from 'moment';
export { DateRange } from 'moment-range';
export const moment = extendMoment(momentLib);
export const dateOnlyFormat = 'YYYY-MM-DD';
export const uniqueMonthFormat = 'YYYY-MM';
